import React, { useState, useRef, useEffect } from "react";

const convert24To12 = (time24) => {
  if (!time24) return { time: "", ampm: "AM" };

  let [hh, mm] = time24.split(":");
  let hour = parseInt(hh, 10);
  let ampm = "AM";

  if (hour >= 12) {
    ampm = "PM";
    if (hour > 12) hour -= 12;
  }

  if (hour === 0) hour = 12;

  return {
    time: `${String(hour).padStart(2, "0")}:${mm}`,
    ampm,
  };
};

const CustomTimePicker = ({ value = "", onChange }) => {
  const wrapperRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [time, setTime] = useState("");
  const [ampm, setAmpm] = useState("AM");

  useEffect(() => {
    if (!value) {
      setTime("");
      setAmpm("AM");
      return;
    }

    if (value.includes(" ")) {
      const [t, a] = value.split(" ");
      setTime(t);
      setAmpm(a);
      return;
    }

    const { time, ampm } = convert24To12(value);
    setTime(time);
    setAmpm(ampm);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleTimeChange = (e) => {
    let val = e.target.value.replace(/\D/g, "");

    if (val.length > 2) {
      val = val.slice(0, 2) + ":" + val.slice(2, 4);
    }

    setTime(val);
    onChange?.(`${val} ${ampm}`);
  };

  const handleSelectAmpm = (val) => {
    setAmpm(val);
    setDropdownOpen(false);
    onChange?.(`${time} ${val}`);
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        border: "1px solid #ccc",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        // width: time ? "20%" : "25%",
        width:'24%',
        padding: "5px 8px",
        background: "#fff",
        position: "relative",
        gap: time ? "0px" : "5px",
      }}
    >
      <input
        type="text"
        value={time}
        onChange={handleTimeChange}
        placeholder="HH:MM"
        maxLength={5}
               style={{ border: "none", outline: "none", width: "50%", fontSize: "14px" }}

      />

      <div
        onClick={() => setDropdownOpen(!dropdownOpen)}
         style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          userSelect: "none",
          fontSize: "14px",
        }}
      >
        {ampm} ▼
      </div>

      {dropdownOpen && (
        <div
         style={{
            position: "absolute",
            top: "100%",
            right: "0",
            border: "1px solid #ccc",
            borderRadius: "6px",
            background: "#fff",
            zIndex: 1000,
            width: "60px",
          }}
        >
          {["AM", "PM"].map((opt) => (
            <div
              key={opt}
              onClick={() => handleSelectAmpm(opt)}
              style={{
                padding: "6px",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomTimePicker;
